module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-prize-04-1e7e41a142cda2b92e143834314a2504.svg";